import React from 'react';
import Footer from '../components/Footer';
import NavBar from '../components/Navbar/NavBar';
import { Security } from '../components/Security';


const SecurityWa = () => {
    return (
        <>
            <NavBar/>
            <Security />
            <Footer />
        </>

    )
}

export default SecurityWa;

